import React from "react";
import { PublicShell, BackButton } from "@/components/Layout";

export default function About() {
  return (
    <PublicShell>
      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
        <BackButton to="/" label="Back to home" />
        <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">About FlexiVouch</p>
        <h1 className="font-display mt-3 text-4xl sm:text-5xl tracking-tight font-bold text-[#0A2540]">
          A flexible stored-value engine for South Africa.
        </h1>
        <p className="mt-6 text-lg text-[#333333] leading-relaxed">
          FlexiVouch is a multi-utility stored-value voucher platform owned and
          operated by Praxio (Pty) Ltd. We build the rails that let merchants
          issue digital vouchers and customers spend them across any service —
          XLearna Premium, airtime, data, electricity and more.
        </p>
        <div className="grid sm:grid-cols-2 gap-6 mt-12">
          <div className="bg-white border border-[#E5E7EB] rounded-2xl p-7">
            <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Our values</p>
            <ul className="mt-4 space-y-3 text-[#333333]">
              <li><strong className="text-[#0A2540]">Trust</strong> — atomic balance updates, immutable audit log.</li>
              <li><strong className="text-[#0A2540]">Simplicity</strong> — one PIN, many services.</li>
              <li><strong className="text-[#0A2540]">Flexibility</strong> — partial redemption until balance is zero.</li>
              <li><strong className="text-[#0A2540]">Financial inclusion</strong> — built for everyone.</li>
            </ul>
          </div>
          <div className="bg-[#0A2540] text-white rounded-2xl p-7">
            <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Praxio (Pty) Ltd</p>
            <p className="mt-3 font-display text-xl">31 5th Street, Commercia<br />Midrand, 1685</p>
            <p className="mt-4 text-white/80">Tel: 079 485 2928<br />info@praxio.co.za</p>
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
